'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Objects = require('../util/Objects');

var _Analytics = require('../util/Analytics');

var _Analytics2 = _interopRequireDefault(_Analytics);

var _Dom = require('../util/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

var _Severity = require('../constants/Severity');

var _Severity2 = _interopRequireDefault(_Severity);

var _EventGroups = require('../constants/EventGroups');

var _EventGroups2 = _interopRequireDefault(_EventGroups);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var NO_MARGIN_CLASS = 'fire-alarm_no-nav-margin-bottom';

var dom = new _Dom2.default(document);

var AlarmContainer = function () {
  function AlarmContainer() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, AlarmContainer);

    this.config = (0, _Objects.defaults)(config, {
      after: null,
      additionalClasses: [],
      before: null,
      parent: null
    });

    this.alarmElements = [];
  }

  _createClass(AlarmContainer, [{
    key: 'addAlarm',
    value: function addAlarm(alarm) {
      if (!alarm.isDismissed()) {
        var alarmElement = alarm.getDomElement();
        if (this.alarmElements.indexOf(alarmElement) === -1) {
          this.alarmElements.push(alarmElement);
          this.getDomElement().appendChild(alarmElement);
          alarm.trackViewEventIfNotTrackedToday();
        }
      }
    }
  }, {
    key: 'removeAllAlarms',
    value: function removeAllAlarms() {
      if (this.domElement) {
        while (this.domElement.firstChild) {
          this.domElement.removeChild(this.domElement.firstChild);
        }
        this.alarmElements = [];
      }
    }
  }, {
    key: 'getDomElement',
    value: function getDomElement() {
      if (this.domElement == null) {
        var additionalClasses = this.config.additionalClasses.join(' ');

        this.domElement = dom.createElement('div', {
          class: 'fire-alarm_alarms ' + additionalClasses
        });
      }

      return this.domElement;
    }
  }, {
    key: 'addNoMarginClass',
    value: function addNoMarginClass() {
      if (!this.addedNoMarginClass) {
        this.getDomElement().classList.add(NO_MARGIN_CLASS);
        this.addedNoMarginClass = true;
      }
    }
  }, {
    key: 'getParent',
    value: function getParent() {
      var _config = this.config,
          after = _config.after,
          before = _config.before,
          parent = _config.parent;


      if (!parent) {
        if (after) {
          this.config.parent = after.parentNode;
        } else if (before) {
          this.config.parent = before.parentNode;
        }
      }

      return this.config.parent;
    }
  }, {
    key: 'render',
    value: function render() {
      var _config2 = this.config,
          after = _config2.after,
          before = _config2.before;

      var parent = this.getParent();

      if (parent) {
        var container = this.getDomElement();
        if (after) {
          var afterBottomMargin = window.getComputedStyle(after).marginBottom;
          // Catch if the margin is 0, '0px' or undefined
          if (!parseInt(afterBottomMargin, 10)) {
            this.addNoMarginClass();
          }
          parent.insertBefore(container, after.nextSibling);
        } else if (before) {
          parent.insertBefore(container, before);
        } else {
          parent.appendChild(container);
        }
      }
    }
  }]);

  return AlarmContainer;
}();

exports.default = AlarmContainer;
module.exports = exports['default'];